<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="container">
    <app-header title="商品详情" />
    <div class="item-detail">
      <!-- 商品轮播图 -->
      <div class="item-swipe">
        <van-swipe :autoplay="3000" style="height: 300px;">
          <van-swipe-item v-for="(image, index) in itemImgs"
                          :key="index">
            <div class="flex-center">
              <img :src="image" width="" height="300" @click="showImage(index)" class="swipe-img"/>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!--预览图-->
      <!--<van-image-preview v-model:show="imageShow" :images="itemImgs" @change="onChange"></van-image-preview>-->

      <!-- 商品基本信息 -->
      <div class="item-info">
        <div class="item-info-title">{{ product.name }}</div>
        <!--原价-->
        <div class="price-con" v-if="priceList.length === 0">
          <span class="coupon-price-old" v-if="product.costPrice">原价: ¥{{product.costPrice}}</span>
          <span class="coupon-price-title"> ¥{{product.price}}</span>
        </div>
        <!--阶梯价格-->
        <div class="item-info-price" style="margin-top: 13px;" v-if="priceList.length > 0">
          <div v-for="(item,index) in priceList"
               v-if="!index"
               class="item"
               :key="index">
            <span class="number">{{item.startCount}}+</span>
            <span class="price" v-if="index == 0" style="font-size: 26px; font-weight: bold;">￥{{item.money}}</span>
            <span class="price" v-if="index > 0">￥{{item.money}}</span>
            <img src="@/assets/up.png"
                 alt=""
                 width="13"
                 height="13"
                 @click="show = false"
                 v-if="show">
            <img src="@/assets/down.png"
                 alt=""
                 width="13"
                 height="13"
                 @click="show = true"
                 v-if="!show">
          </div>
          <div class="item"
               v-for="(item,index) in priceList"
               v-if="index!=0"
               :key='item.id'
               v-show="show">
            <span class="number">{{item.startCount}}+</span>
            <span class="price">￥{{item.money}}</span>
          </div>
        </div>
      </div>
      <!--商品权益明细-->
      <div class="item-income">
        <span v-show="!showQy" @click="showQy = true">商品权益明细</span>
        <span v-show="showQy" @click="showQy = false">商品权益明细</span>
        <img src="@/assets/up.png"
             alt=""
             width="13"
             height="13" v-if="showQy" style="position: relative;top: 2.5px;">

        <img src="@/assets/down.png"
             alt=""
             width="13"
             height="13" v-if="!showQy" style="position: relative;top: 2.5px;">
      </div>

      <div v-show="showQy" class="popup" style="padding: 0 12px;">
        <div style="display: flex;justify-content: space-between;margin-top: 10px">
          <p style="font-size: 14px; color: #666666;">自购返利</p>
          <p style="font-size: 14px;color: red;">赚￥{{product.rebate}}%</p>
        </div>
        <div style="display: flex;justify-content: space-between;margin-top: 10px">
          <p style="font-size: 14px; color: #666666;">推荐返利</p>
          <p style="font-size: 14px;color: red;">赚￥{{product.shareRebate}}%</p>
        </div>
      </div>

      <!-- 商品参数 -->
      <div class="item-param">
        <div class="title">商品参数</div>
        <!-- <div class="text" style="display: flex;">
          <span class="key">产品名称: </span>
          <span>{{ product.name }}</span>
        </div> -->
        <!--<div class="text" style="display: flex;" v-if="product.costPrice">-->
        <!--<span class="key">原价</span>-->
        <!--<span class="mao">：</span>-->
        <!--<span>{{ product.costPrice }}元</span>-->
        <!--</div>-->
        <div class="text" style="display: flex;" v-if="product.unitNumber">
          <span class="key">最小包装数量</span>
          <span class="mao">：</span>
          <span>{{ product.unitNumber }}</span>
        </div>
        <div class="text" style="display: flex;">
          <span class="key">货期</span>
          <span class="mao">：</span>
          <span v-if="product.isExist===0">现货</span>
          <span v-if="product.isExist===1">货期{{ product.delivery }}天</span>
        </div>
        <div class="text" style="display: flex;">
          <span class="key">品牌</span>
          <span class="mao">：</span>
          <span>{{ product.brand }}</span>
        </div>
        <div class="text" style="display: flex;">
          <span class="key" v-if="product.type==0">封装</span>
          <span class="key" v-if="product.type>0">规格</span>
          <span class="mao">：</span>
          <span>{{ product.packages }}</span>
        </div>
        <div class="text" style="display: flex;">
          <span class="key">型号</span>
          <span class="mao">：</span>
          <span>{{ product.model }}</span>
        </div>
        <template v-if="product.productAttrList.length > 0">
          <div class="text" style="display: flex;" v-for="(item,index) in product.productAttrList">
            <span class="key">{{item.productText}}</span>
            <span class="mao">：</span>
            <span>{{ item.productValue }}</span>
          </div>
        </template>

      </div>
      <!-- 商品详情 -->
      <div class="item-desc">
        <div class="title">商品详情</div>
        <!--商品规格书-->
        <div class="instructions" v-if="product.spec">
          <div>产品规格书</div>
          <div class="instructions" @click="handleDownload">
            <span>查看</span>
            <img src="@/assets/addgo.png" alt="" width="14" height="14">
          </div>
        </div>

        <div class="wrap" v-html="product.detail" @click="showImg($event)"></div>
      </div>

    </div>
    <div class="footer">
      <div class="footer-icon">
        <img src="@/assets/alibaba.png"
             alt="客服"
             width="20"
             height="20">
        <span>客服</span>
      </div>
      <div class="footer-icon" @click="$router.push({path:'/cart'})">
        <img src="@/assets/cart-op.png"
             alt="购物车"
             width="24"
             height="24" style="width: 24px;height: 24px;">
        <span>购物车</span>
      </div>
      <div @click="_saveShopCollect"
           class="footer-icon">
        <img v-show="iscollect"
             src="../../assets/collect01.png"
             alt="收藏">
        <img v-show="!iscollect"
             src="../../assets/collect.png"
             alt="收藏">
        <span>收藏</span>
      </div>
      <div class="footer-button-cart"
           @click="buyproduct(0)">
        加入购物车
      </div>
      <div class="footer-button-buy"
           @click="buyproduct(1)">
        立即购买
      </div>
    </div>

    <!--Sku 商品规格-->
    <van-sku v-model="skuShow"
             :sku="sku"
             :goods="goods"
             :goods-id="product.id"
             :quota="quota"
             :quota-used="quotaUsed"
             :start-sale-num="quotaUsed"
             :hide-stock="sku.hide_stock"
             @stepper-change="onStepperChange"
             @buy-clicked="onBuyClicked"
             @add-cart="onAddCartClicked">

      <!-- 自定义 sku-header-price -->
      <template #sku-header-price="props">
        <div class="van-sku__goods-price">
          <span class="van-sku__price-symbol">￥</span>
          <span class="van-sku__price-num">{{ price }}</span>
        </div>
      </template>
      <!--自定义 sku stepper-->
      <template #sku-messages="props">
        <div class="van-sku-group-container"></div>
        <div class="van-sku-stepper-stock">
          <div class="van-sku-stepper-container">
            <div class="van-sku__stepper-title">总计</div>
            <div class="van-cell__value van-field__value">
              <div>{{selectedNum}} * {{product.unitNumber}} * {{price}} = {{total}}</div>
            </div>
          </div>
        </div>
      </template>
      <!-- 自定义 sku actions -->
      <template #sku-actions="props">
        <div class="van-sku-actions">
          <!--<div class="submit" @click="props.skuEventBus.$emit('sku:buy')">确定</div>-->
          <div class="submit"
               @click="props.skuEventBus.$emit('sku:addCart')">确定
          </div>
        </div>
      </template>
    </van-sku>


  </div>
</template>

<script>
  import store from '@/store'
  import {addShopCart} from '@/api/cart'
  import {saveShopTrack} from '@/api/track/index.js'
  import {downloadFile} from '@/api/file'
  import {downloadRes} from '@/utils/utils'
  import {getShopProduct, queryShopSectionList, querysysProductStockList, queryShopSkuList} from '@/api/product'
  import {queryShopCollectPage, saveShopCollect, updateShopCollect, queryShopCollectList} from '@/api/collect'
  import {ImagePreview} from 'vant';
  export default {
    name: 'Index',
    computed: {
      itemImgs() {
        let pics = [];
        if (this.product.albumPics === undefined || this.product.albumPics == null || this.product.albumPics === '') {
          pics.push(this.product.image);
          return pics;
        }
        let albumPics = this.product.albumPics.split(',');
        for (let i = 0; i < albumPics.length; i++) {
          pics.push(albumPics[i]);
        }
        return pics;
      },
      total() {
        return (this.selectedNum * this.product.unitNumber * this.price).toFixed(2);
      }
    },
    data() {
      return {
        id: '',
        tab: '',
        price: '',
        isBack: false,
        show: false,
        imageShow: false,
        showQy: false,
        skuShow: false,
        selectedNum: 1,
        isbuy: '',
        product: {
          productAttrList: []
        },
        //预览图起始
        startPosition: 1,

        priceList: [],
        // 商品轮播图
        //itemImgs: ['https://img.yzcdn.cn/vant/apple-1.jpg', 'https://img.yzcdn.cn/vant/apple-2.jpg'],
        desc: '',
        // 添加购物车和点击购买回调函数接收的 skuData 对象结构
        skuData: {
          // 商品 id
          goodsId: '',
          // 选择的商品数量
          selectedNum: 1,
          // 选择的 sku 组合
          selectedSkuComb: {
            id: '',
            price: '',
            s1: '001',
            stock_num: '',
            properties: [],
            property_price: 0
          }
        },
        goodsId: '',
        quota: 0,
        quotaUsed: 1,
        sku: {
          // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
          // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
          tree: [
            {
              k: '颜色',
              k_id: '1',
              v: [
                {
                  id: '30349',
                  name: '天蓝色',
                  imgUrl: ''
                },
                {
                  id: '1215',
                  name: '白色'
                }
              ],
              k_s: 's1'
            },
            {
              k: '尺寸',
              k_id: '2',
              v: [
                {
                  id: '111',
                  name: '1',
                  imgUrl: ''
                },
                {
                  id: '222',
                  name: '2'
                }
              ],
              k_s: 's2'
            }
          ],
          // 所有 sku 的组合列表，如下是：白色1、白色2、天蓝色1、天蓝色2
          list: [],
          price: '', // 默认价格（单位元）
          stock_num: 100000000, // 商品总库存
          none_sku: false, // 是否无规格商品
          messages: [],
          hide_stock: true // 是否隐藏剩余库存
        },
        goods: {
          // 默认商品 sku 缩略图
          picture: 'https://img.yzcdn.cn/1.jpg'
        },
        messageConfig: {
          // 数据结构见下方文档
        },
        iscollect: '',
        collectId: ''

      }
    },
    created() {
      this.id = this.$route.query.id
      this.tab = this.$route.query.tab
      this.getProduct()
      this._saveShopTrack()
      this._queryShopCollectList()
      this._querysysProductStockList()
    },
    watch: {
      '$route': function(val) {
        if(val.query && val.query.id && (val.query.from == 'productDetail' || val.name == 'productDetail')) {
          this.id = this.$route.query.id
          this.tab = this.$route.query.tab
          this.getProduct()
          this._saveShopTrack()
          this._queryShopCollectList()
          this._querysysProductStockList()
        } else {

        }
      }
    },
    beforeRouteLeave (to, from, next) {
      this.product = {
        productAttrList: []
      }
      next()
    },
    methods: {
      showImage(index){
        ImagePreview({
          images: this.itemImgs,
          startPosition: index,
        });
      },
      showImg(e) {
        if (e.target.nodeName == 'IMG') {//判断点击富文本内容为img图片
          let src = e.target.currentSrc;
          ImagePreview({
            images:[e.target.currentSrc],
            showIndex:false,
            loop:false,
          })
        } else {
          //console.log("点击内容不为img")
        }
      },
      back() {
        // this.$route.params.tab = this.tab
        this.$router.go(-1)
        // this.$router.push("/" + this.$route.query.tab)
      },
      onChange(index) {
        this.index = index;
      },
      handleDownload() {
        this.$router.push({
          path: '/product/pdf',
          query: {
            pdf: this.product.spec
          }
        })
        //window.open(this.product.spec,'_blank')
        // let url = this.product.spec.substring(this.product.spec.lastIndexOf("/")+1);
        // downloadFile(url).then(res=>{
        //   if (res.data && res.status===200) {
        //     downloadRes(res.data,url)
        //   }else{
        //     this.$message({
        //       message:'文件解析失败',
        //       type:'error',
        //       offset:300
        //     })
        //   }
        //
        // })
      },
      getProduct() {
        let user = JSON.parse(localStorage.getItem("userInfo"))
        const params = {
          id: this.id,
          uid: user ? user.id : '',
        }
        getShopProduct(params).then(res => {
          if (res.success) {
            this.product = res.data
            this.priceList = this.product.productLadderList
            this.goods.picture = this.product.image
            this.skuData.goodsId = this.product.id
            this.skuData.selectedSkuComb.id = this.product.id
            this.skuData.selectedSkuComb.price = this.product.price
            this.sku.price = this.product.price
            this.price = this.product.price
            if (this.product.detail) {
              this.product.detail = this.product.detail.replace(/\<img/gi, '<img style="width:100%;height:auto"')
            }
          }
        })
      },
      // 查询是否收藏
      _queryShopCollectList() {
        var user = localStorage.getItem('userInfo')
        if (user != null) {
          user = JSON.parse(user)
          const params = {
            pid: this.id,
            uid: user.id
          }
          queryShopCollectList(params).then((res) => {
            if (res.data.length) {
              this.iscollect = res.data[0].iscollect
              this.collectId = res.data[0].id
            }
          })
        }
      },
      // 添加收藏
      _saveShopCollect() {
        if (this.collectId === '') {
          var user = localStorage.getItem('userInfo')
          user = JSON.parse(user)
          const params = {
            pid: this.id,
            uid: user.id
          }
          saveShopCollect(params).then((res) => {
            if (res.success) {
              this._queryShopCollectList()
              this.$toast.success('收藏成功')
            }
          })
        } else {
          const params = {
            id: this.collectId,
            iscollect: this.iscollect ? 0 : 1
          }
          updateShopCollect(params).then((res) => {
            if (res.success) {
              if (params.iscollect) {
                this.$toast.success('收藏成功')
              } else {
                this.$toast.success('取消收藏成功')
              }
              this._queryShopCollectList()
            }
          })
        }
      },
      // 规格
      _queryShopSkuList() {
        const params = {
          pid: this.id
        }
        queryShopSkuList(params).then((res) => {
          if (res.success) {

          }
        })
      },
      // 颜色库存
      _querysysProductStockList() {
        const params = {
          pid: this.id
        }
        querysysProductStockList(params).then((res) => {
          if (res.success) {
            const tempArr = []
            const tempId = []
            res.data.forEach((item) => {
              tempArr.push(item.skunames.split(','))
              tempId.push(item.skuids.split(','))
            })
            const titleArr = []
            const idsArr = []
            tempArr.forEach((item) => {
              item.forEach((val) => {
                titleArr.push(val.split('#'))
              })
            })
            tempId.forEach((item) => {
              item.forEach((val) => {
                idsArr.push(val.split('#'))
              })
            })
            this.sku.tree = []
            titleArr.forEach((item, index) => {
              let tempState = true
              this.sku.tree.forEach((val) => {
                if (item[0] === val.k) {
                  tempState = false
                }
              })
              if (tempState) {
                this.sku.tree.push(
                  {
                    k: item[0],
                    k_id: idsArr[index][0],
                    v: [],
                    k_s: 's' + idsArr[index][0]
                  }
                )
              }
            })
            titleArr.forEach((item, index) => {
              this.sku.tree.forEach((val) => {
                if (item[0] == val.k) {
                  val.v.push({
                    name: item[1],
                    id: idsArr[index][1]
                  })
                }
              })
            })
            this.sku.list = []
            res.data.forEach((item, index) => {
              this.sku.list.push({
                id: item.id,
                price: parseInt(item.price) * 100,
                discount: item.dprice,
                stock_num: 100000000, // 库存
                goods_id: this.id
              })

              const skuidsArr = item.skuids.split(',')
              const sidArr = []

              skuidsArr.forEach((item) => {
                sidArr.push(item.substring(item.indexOf('#') + 1, item.length))
              })
              this.sku.tree.forEach((val) => {
                val.v.forEach((v) => {
                  sidArr.forEach((k) => {
                    if (v.id == k) {
                      this.sku.list[index][val.k_s] = k
                    }
                  })
                })
              })
            })
            // 去除重复规格
            this.sku.tree.forEach((item, index) => {
              let map = new Map()
              item.v.forEach((val) => {
                map.set(val.id, val.name)
              })
              item.v = []
              map.forEach((v, k) => {
                item.v.push({id: k, name: v})
              })
            })
          }
        })
      },

      // 添加我的足迹
      _saveShopTrack() {
        const hasGetUserInfo = store.getters.id
        if (hasGetUserInfo) {
          const params = {
            pid: this.id,
            uid: this.$store.getters.id
          }
          saveShopTrack(params).then((res) => {
          })
        }
      },
      buyproduct(val) {
        // 获取用户信息
        const hasGetUserInfo = localStorage.getItem("userInfo")
        if (hasGetUserInfo != null) {
          this.isbuy = val
          this.skuShow = true
        } else {
          this.$router.push({
            path: '/login'
          })
        }
      },
      onStepperChange(value) {
        this.price = this.product.price;
        if (value > 100000000){
          this.$toast({
            message: '最大数量不能超过 100000000',
            duration: 1500
          })
          return;
        }
        if (value < 1) {
          this.$toast({
            message: '至少选择1件',
            duration: 1500
          })
          return;
        }else{
          this.selectedNum = value;
          for (let i = this.priceList.length - 1; i >= 0; i--) {
            let temp = this.priceList[i];
            if (value >= temp.startCount) {
              this.price = temp.money;
              return;
            }
          }
        }
      },
      // gou
      onAddCartClicked(data) {

        const tempName = []
        this.sku.tree.forEach((item) => {
          item.v.forEach((val) => {
            for (const key in data.selectedSkuComb) {
              if (val.id == data.selectedSkuComb[key]) {
                tempName.push(val.name)
              }
            }
          })
        })

        if (!this.isbuy) {
          var user = localStorage.getItem('userInfo')
          user = JSON.parse(user)
          if (!user.id) {
            this.$router.push({
              path: '/login'
            })
            return;
          }
          const form = {
            uid: user.id,
            pid: this.id,
            number: data.selectedNum,
            sid: data.selectedSkuComb ? data.selectedSkuComb.id : "",
            pdescription: tempName.join(','),
            price: this.price,
          }
          addShopCart(form).then(res => {
            if (res.success) {
              this.skuShow = false
              this.$toast({
                message: '已添加至购物车',
                duration: 1500
              })
            }
          })
        } else {
          this.$router.push({
            path: '/order/add',
            query: {
              gName: tempName.join(','),
              num: data.selectedNum,
              sid: data.selectedSkuComb ? data.selectedSkuComb.id : "",
              pid: this.id,
              price: this.price,
              image: this.product.image,
              name: this.product.name,
              unitNumber: this.product.unitNumber,
              freightMoney: this.product.freightMoney
            }
          })
        }
      },
      onBuyClicked() {
        this.$router.push({
          path: '/order/add'
        })
      }
    }
  }
</script>


<style lang="less" scoped>
  .container {
    /*width: 100vw;*/
    /*height: auto;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*overflow-y: auto;*/
    padding-top: 50px;
    padding-bottom: 50px;
    font-size: 14px;
    background-color: #ffffff;
    .item-detail {
      .swipe-img{
        max-width: 100%;
        max-height: 100%;
        width:auto;
        height:auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%,-50%,0);
        -webkit-transform: translate3d(-50%,-50%,0);
      }
      .item-info {
        margin: 12px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-radius: 4px;
        padding: 8px 10px;
        .item-info-title {
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: rgba(51, 51, 51, 1);
        }
        .price-con {
          height: 25px;
          padding: 6px 0 0;
          line-height: 25px;
          text-align: center;
          .coupon-price-title {
            vertical-align: baseline;
            font-family: PingFangSC-Medium;
            font-size: 26px;
            color: rgba(254, 0, 59, 1);
            font-weight: bold;
          }
          .coupon-price-old {
            margin-left: 8px;
            vertical-align: baseline;
            text-decoration: line-through;
            line-height: 20px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #9b9b9b;
          }
        }
        .item-info-price {
          text-align: center;
          .item {
            span {
              display: inline-block;
            }
            .number {
              height: 18px;
              font-size: 13px;
              font-weight: 400;
              line-height: 18px;
              color: rgba(102, 102, 102, 1);
            }
            .price {
              height: 20px;
              font-size: 14px;
              font-weight: bold;
              line-height: 20px;
              color: rgba(254, 0, 59, 1);
            }
          }
        }
      }
      .item-income {
        height: 18px;
        font-size: 13px;
        font-weight: bold;
        line-height: 21px;
        color: rgba(254, 0, 59, 1);
        padding: 0 12px;
      }
      .item-param {
        padding: 0 12px;
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        .title {
          height: 22px;
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: rgba(51, 51, 51, 1);
        }
        .title-eng {
          height: 20px;
          line-height: 20px;
          overflow: hidden;
        }
        .text {
          margin-top: 8px;
          .key {
            display: inline-block;
            width: 67px;
            text-align: justify;
            height: 20px;
            line-height: 20px;
            overflow: hidden;
          }
          .key::after {
            content: "";
            display: inline-block;
            width: 100%;
          }
          span {
            display: inline-block;
            height: 20px;
            line-height: 20px;
          }
        }
        .other {
          display: flex;
          flex-direction: row;
          .left {
            width: 67px;
            span {
              display: inline-block;
              width: 67px;
              text-align: justify;
              height: 20px;
              line-height: 20px;
              overflow: hidden;
            }
            span::after {
              content: "";
              display: inline-block;
              width: 100%;
            }
          }
          .right {
            flex: 1;
            .item {
              display: flex;
              justify-content: space-around;
              margin-bottom: 8px;
            }
          }
        }
      }
      .item-desc {
        padding: 0 12px;
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        .title {
          height: 22px;
          font-size: 16px;
          font-weight: bold;
          line-height: 22px;
          color: rgba(51, 51, 51, 1);
        }
        .title-eng {
          overflow: hidden;
        }
        .instructions {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(51, 51, 51, 1);
        }

        .wrap img {
          width: 100%;
        }
      }
    }

    .wrap img {
      width: 100%;
    }

    .footer {
      background-color: #fff;
      width: 100vw;
      height: 50px;
      display: flex;
      flex-direction: row;
      align-items: center;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      .footer-icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-width: 48px;
        height: 100%;
        color: #646566;
        font-size: 10px;
        line-height: 1;
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        img {
          width: 20px;
          height: 20px;
          margin-bottom: 6px;
        }
      }
      .footer-button-cart {
        flex: 1;
        height: 40px;
        border: none;
        margin-left: 5px;
        background: linear-gradient(
          360deg,
          rgba(244, 148, 4, 1) 0%,
          rgba(242, 139, 16, 0.73) 100%
        );
        border-radius: 4px 0px 0px 4px;
        font-size: 16px;
        font-weight: 400;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
      }
      .footer-button-buy {
        flex: 1;
        height: 40px;
        border: none;
        margin-right: 5px;
        border-radius: 0px 4px 4px 0px;
        background: linear-gradient(
          0deg,
          rgba(244, 4, 66, 1) 0%,
          rgba(226, 23, 75, 0.73) 100%
        );
        font-size: 16px;
        font-weight: 400;
        line-height: 40px;
        text-align: center;
        color: #ffffff;
      }
    }
    .van-sku-actions {
      .submit {
        width: 100%;
        height: 40px;
        line-height: 40px;
        background: linear-gradient(
          0deg,
          rgba(244, 4, 66, 1) 0%,
          rgba(226, 23, 75, 0.73) 100%
        );
        border-radius: 4px;
        text-align: center;
        color: #ffffff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/detail/index.vue